"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowBuilderProvider = exports.useWorkflowBuilderContext = exports.WorkflowBuilderContext = void 0;
const react_1 = __importStar(require("react"));
const use_query_params_1 = require("use-query-params");
const useFindWorkflows_1 = require("./hooks/useFindWorkflows");
const useFindTaskTypes_1 = require("./task-types/hooks/useFindTaskTypes");
exports.WorkflowBuilderContext = 
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(0, react_1.createContext)(null);
function useWorkflowBuilderContext(params) {
    const context = (0, react_1.useContext)(exports.WorkflowBuilderContext);
    if (!context && !(params === null || params === void 0 ? void 0 : params.ignoreUndefined)) {
        throw new Error('useWorkflowBuilderContext must be used within the context of the WorkflowBuilderProvider component');
    }
    return context;
}
exports.useWorkflowBuilderContext = useWorkflowBuilderContext;
const WorkflowBuilderProvider = ({ children }) => {
    const [includeDeleted] = (0, use_query_params_1.useQueryParam)('deleted', (0, use_query_params_1.withDefault)(use_query_params_1.BooleanParam, false));
    const [selectedWorkflow, setSelectedWorkflow] = (0, react_1.useState)();
    const findWorkflowsApi = (0, useFindWorkflows_1.useFindWorkflows)();
    const { data: taskTypes, findTaskTypes } = (0, useFindTaskTypes_1.useFindTaskTypes)();
    const { findWorkflows } = findWorkflowsApi;
    (0, react_1.useEffect)(() => findWorkflows({ limit: 100, includeDeleted }), [includeDeleted, findWorkflows]);
    (0, react_1.useEffect)(() => findTaskTypes(), [findTaskTypes]);
    return (react_1.default.createElement(exports.WorkflowBuilderContext.Provider, { value: Object.assign(Object.assign({}, findWorkflowsApi), { taskTypes,
            selectedWorkflow,
            findTaskTypes,
            setSelectedWorkflow }) }, children));
};
exports.WorkflowBuilderProvider = WorkflowBuilderProvider;
//# sourceMappingURL=WorkflowBuilderContext.js.map